<template>
  <!-- loading -->
  <div>
    <div class="row app-list-loading" v-if="loading">
      <div class="col-12">
        <div
          class="text-center"
          style="padding: 1.8rem 0; background-color: #fff"
        >
          <a href="javascript:void(0);">
            <i class="bx bx-loader bx-spin font-size-20 align-middle me-2"></i>
            加载中...
          </a>
        </div>
      </div>
    </div>

    <div class="row app-list-loading" v-if="listNull">
      <div class="col-12">
        <div
          class="text-center"
          style="padding: 1.8rem 0; background-color: #fff"
        >
          <a href="javascript:void(0);">
            {{ content ? content : "暂无数据" }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- loading -->
</template>

<script>
export default {
  name: "app-list-loading",
  props: ["visible"],
  data() {
    return {
      loading: false,
      listNull: false,
      content: "",
    };
  },

  watch: {
    visible() {
      if (this.visible === true) {
        this.loading = true;
      } else if (this.visible === false) {
        this.loading = false;
      } else if (this.visible === 1) {
        this.loading = false;
        this.listNull = true;
      }
    },
  },

  created() {
    // console.log("加载中", this.visible);
    if (this.visible === true) {
      this.loading = true;
    } else if (this.visible === false) {
      this.loading = false;
    }
  },

  mounted() {},

  methods: {
    show() {
      this.content = "";
      this.listNull = false;
      this.loading = true;
    },

    hide(items) {
      this.content = "";
      this.loading = false;
      if (items) {
        if (items.length < 1) {
          this.listNull = true;
        } else {
          this.listNull = false;
        }
      } else {
        this.listNull = true;
      }
    },

    text(code) {
      this.content = code;
      this.listNull = true;
    },
  },
};
</script>

<style scoped>
.app-list-loading .text-center a {
  font-size: 15px;
}
</style>
